import React, { useCallback, useEffect, useState } from 'react'
import { Button, Card, Table } from 'react-bootstrap'
import CreateCampaignModal from './components/CreateCampaignModal'
import config from '../../config'
import Cookies from 'js-cookie'
import Swal from 'sweetalert2'
import moment from 'moment'

export const CAMPAIGN_STATUS = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
}

const Campaign = () => {
  const [campaigns, setCampaigns] = useState([])
  const [selectedCampaign, setSelectedCampaign] = useState(null)
  const [isShowModal, setIsShowModal] = useState(false)
  const [pagination, setPagination] = useState({ page: 1, hasNext: false })

  const fetchCampaigns = useCallback(async (page = 1) => {
    try {
      const response = await fetch(`${config.apiAdminGateway}/api/v1/admin/notification/campaign/all?page=${page}`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${Cookies.get('accessToken')}`,
        },
      }).then((res) => res.json())

      if (response.status.code !== 0) throw new Error('Error fetching campaigns')

      if (page > 1) {
        setCampaigns((prev) => [...prev, ...response.data])
      } else {
        setCampaigns(response.data)
      }
      setPagination({
        page: page,
        hasNext: response.pagination.hasNext,
      })
    } catch {
      Swal.fire({
        title: 'เกิดข้อผิดพลาดระหว่างดึงข้อมูลแคมเปญ',
        text: 'กรุณาลองใหม่อีกครั้ง',
        icon: 'error',
      })
    }
  }, [])

  useEffect(() => {
    fetchCampaigns()
  }, [fetchCampaigns])

  const handleClickLoadMore = () => {
    fetchCampaigns(pagination.page + 1)
  }

  const handleClickDeleteCampaign = async (campaignId) => {
    const result = await Swal.fire({
      title: 'ต้องการจะลบแคมเปญนี้ใช่หรือไม่',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'ใช่',
      cancelButtonText: 'ไม่ใช่',
    })
    if (!result.isConfirmed) return

    try {
      const response = await fetch(`${config.apiAdminGateway}/api/v1/admin/notification/campaign/${campaignId}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${Cookies.get('accessToken')}`,
        },
      }).then((res) => res.json())

      if (response.status.code !== 0) throw new Error(response.status.message)

      Swal.fire({
        title: 'ลบแคมเปญสำเร็จ',
        icon: 'success',
      })
    } catch {
      Swal.fire({
        title: 'เกิดข้อผิดพลาดระหว่างการลบแคมเปญ',
        text: 'กรุณาลองใหม่อีกครั้ง',
        icon: 'error',
      })
    } finally {
      setCampaigns((prev) => prev.filter((campaign) => campaign.id !== campaignId))
    }
  }

  const handleClickCreateCampaign = () => {
    setSelectedCampaign(null)
    setIsShowModal(true)
  }

  const handleClickShowImage = (imageUrl) => {
    Swal.fire({
      imageUrl,
      imageAlt: 'รูปภาพแคมเปญ',
      confirmButtonText: 'ปิด',
    })
  }

  return (
    <Card>
      <Card.Header>
        <Card.Title>Campaign</Card.Title>
        <Button variant="info light" onClick={handleClickCreateCampaign}>
          สร้างแคมเปญใหม่
        </Button>
      </Card.Header>
      <Card.Body>
        <Table responsive bordered hover className="text-center">
          <thead>
            <tr>
              <th>ชื่อแคมเปญ</th>
              <th>คำอธิบาย</th>
              <th>รูปภาพ</th>
              <th>ข้อความบนปุ่ม</th>
              <th>ลิ้งค์</th>
              <th>วันที่สร้าง</th>
              <th>สถานะ</th>
              <th>แก้ไข</th>
              <th>ลบ</th>
            </tr>
          </thead>
          <tbody>
            {campaigns &&
              campaigns.map((campaign, i) => {
                if (!campaign?.id) return null
                return (
                  <tr key={i}>
                    <td>{campaign.title}</td>
                    <td>{campaign.description}</td>
                    <td>
                      <Button
                        variant="primary light"
                        onClick={() => {
                          handleClickShowImage(campaign.imageUrl)
                        }}
                      >
                        <i className="fa fa-image mr-1" />
                      </Button>
                    </td>
                    <td>{campaign.redirectUrl.name}</td>
                    <td>{campaign.redirectUrl.url}</td>
                    <td>{moment(campaign.createdAt).format('DD/MM/YYYY HH:mm')}</td>
                    <td className={campaign.status === CAMPAIGN_STATUS.ACTIVE ? 'text-success' : 'text-danger'}>
                      {campaign.status}
                    </td>
                    <td>
                      <Button
                        variant="primary light"
                        onClick={() => {
                          setSelectedCampaign(campaign)
                          setIsShowModal(true)
                        }}
                      >
                        <i className="fa fa-pencil"></i>
                      </Button>
                    </td>
                    <td>
                      <Button
                        variant="danger light"
                        onClick={() => {
                          handleClickDeleteCampaign(campaign.id)
                        }}
                      >
                        <i className="fa fa-trash"></i>
                      </Button>
                    </td>
                  </tr>
                )
              })}
          </tbody>
        </Table>
        {pagination.hasNext && (
          <div className="d-flex">
            <Button className="mx-auto" onClick={handleClickLoadMore}>
              โหลดเพิ่มเติม
            </Button>
          </div>
        )}
      </Card.Body>

      {isShowModal && (
        <CreateCampaignModal
          show={isShowModal}
          selectedCampaign={selectedCampaign}
          handleCloseModal={() => setIsShowModal(false)}
          onCreatedCampaign={() => {
            setIsShowModal(false)
            fetchCampaigns()
          }}
        />
      )}
    </Card>
  )
}

export default Campaign
